import axios from "axios";

let _singleton = true;
let _instance: any;
let _advancedSearch: any = null;

class BreadcrumbService {
  constructor() {
    if (_singleton) {
      throw new SyntaxError("This is singleton class");
    }
  }

  static get instance() {
    if (!_instance) {
      _singleton = false;
      _instance = new BreadcrumbService();
      _singleton = true;
    }
    return _instance;
  }

  get advancedSearch() {
    return _advancedSearch;
  }
  set advancedSearch(value) {
    _advancedSearch = value;
  }
}

export default BreadcrumbService;
